/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Partnerships_StepsInputs */

const en_directory_resources_partnerships_steps = /** @type {(inputs: Directory_Resources_Partnerships_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline your audience|Share the campaign goal|Include your timeline`)
};

const zh_directory_resources_partnerships_steps = /** @type {(inputs: Directory_Resources_Partnerships_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`说明你的受众|分享活动目标|附上时间安排`)
};

/**
* | output |
* | --- |
* | "Outline your audience\|Share the campaign goal\|Include your timeline" |
*
* @param {Directory_Resources_Partnerships_StepsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_partnerships_steps = /** @type {((inputs?: Directory_Resources_Partnerships_StepsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Partnerships_StepsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_partnerships_steps(inputs)
	return zh_directory_resources_partnerships_steps(inputs)
});
export { directory_resources_partnerships_steps as "directory.resources.partnerships.steps" }